import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3.407 7.169c-.005.044-.007.09-.007.135v9.392a1.4 1.4 0 0 0 1.4 1.4h14.4a1.4 1.4 0 0 0 1.4-1.4V7.51l-8.086 4.852a1 1 0 0 1-1.055-.017L3.407 7.17Zm1.731-1.265 6.88 4.423 7.354-4.412a1.414 1.414 0 0 0-.172-.01H5.138ZM1.4 7.304a3.4 3.4 0 0 1 3.4-3.4h14.4a3.4 3.4 0 0 1 3.4 3.4v9.392a3.4 3.4 0 0 1-3.4 3.4H4.8a3.4 3.4 0 0 1-3.4-3.4V7.304Z"
  />,
  'Mail1'
)
